import EmptyProductLogo from '../../../../assets/images/emptyProductLogo.svg';

/**
 * Redesigned product header for the new UI.
 * Renders a tall hero image on modal, tight typography, and
 * data-driven tag pills below the title.
 */
const ProductInfo = ({ product, isModal = false, coupon }) => {
  if (!product) return null;

  const platformTags = product?.tags?.platformTags || [];
  const customTags = product?.tags?.customProductTags || [];

  const hasWebPlatform = platformTags.some((tag) => tag.isWeb);
  const hasKioskPlatform = platformTags.some((tag) => tag.isKiosk);
  const hasMobilePlatform = platformTags.some((tag) => tag.isMobile);
  const availablePlatformsCount = [
    hasWebPlatform,
    hasKioskPlatform,
    hasMobilePlatform,
  ].filter(Boolean).length;
  const showWebsiteOnlyTag =
    platformTags.length > 0 && availablePlatformsCount === 1 && hasWebPlatform;

  const buyCount = coupon?.BuyItemCount || coupon?.buyItemCount || 1;
  const getCount = coupon?.GetItemCount || coupon?.getItemCount || 1;

  if (isModal) {
    return (
      <div>
        {/* Hero image */}
        <div
          className="w-full overflow-hidden"
          style={{
            aspectRatio: '16/10',
            background: 'var(--ui-line)',
            borderRadius: '0',
          }}
        >
          <img
            src={product.imagepath || EmptyProductLogo}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Title block */}
        <div className="px-6 sm:px-8 pt-5 pb-4">
          {coupon?.type === 2 && (
            <div
              className="inline-flex items-center gap-2 mb-3"
              style={{
                padding: '5px 12px',
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                background: '#D97706',
                color: '#FFFFFF',
                borderRadius: '100px',
              }}
            >
              Buy {buyCount} · Get {getCount} free
            </div>
          )}

          <h1
            className="leading-[1.15]"
            style={{
              fontSize: '26px',
              fontWeight: 800,
              letterSpacing: '-0.028em',
              color: 'var(--ui-ink)',
              margin: 0,
            }}
          >
            {product.name}
          </h1>

          {product.description && (
            <p
              className="mt-2"
              style={{
                fontSize: '14px',
                lineHeight: 1.5,
                color: 'var(--ui-ink-2)',
                margin: '8px 0 0',
              }}
            >
              {product.description}
            </p>
          )}

          {(showWebsiteOnlyTag || customTags.length > 0) && (
            <div className="flex flex-wrap gap-[6px] mt-4">
              {showWebsiteOnlyTag && (
                <span
                  style={{
                    padding: '3px 9px',
                    borderRadius: '100px',
                    fontSize: '10.5px',
                    fontWeight: 700,
                    letterSpacing: '0.02em',
                    background: 'rgba(21, 128, 61, 0.1)',
                    color: 'var(--ui-green)',
                  }}
                >
                  Web only
                </span>
              )}
              {customTags.map((tag) => (
                <span
                  key={tag.id}
                  style={{
                    padding: '3px 9px',
                    borderRadius: '100px',
                    fontSize: '10.5px',
                    fontWeight: 700,
                    letterSpacing: '0.01em',
                    backgroundColor: tag.color,
                    color: tag.textColor,
                  }}
                >
                  {tag.text}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Full-page layout (non-modal)
  return (
    <div className="flex flex-col">
      <div
        className="w-full overflow-hidden"
        style={{
          aspectRatio: '1/1',
          background: 'var(--ui-line)',
          borderRadius: '20px',
          marginBottom: '20px',
        }}
      >
        <img
          src={product.imagepath || EmptyProductLogo}
          alt={product.name}
          className="w-full h-full object-cover"
        />
      </div>

      <h1
        style={{
          fontSize: '24px',
          fontWeight: 800,
          letterSpacing: '-0.028em',
          lineHeight: 1.15,
          color: 'var(--ui-ink)',
          margin: '0 0 6px',
        }}
      >
        {product.name}
      </h1>

      {product.description && (
        <p
          style={{
            fontSize: '14px',
            lineHeight: 1.5,
            color: 'var(--ui-ink-2)',
            margin: 0,
          }}
        >
          {product.description}
        </p>
      )}

      {(showWebsiteOnlyTag || customTags.length > 0) && (
        <div className="flex flex-wrap gap-[6px] mt-4">
          {showWebsiteOnlyTag && (
            <span
              style={{
                padding: '3px 9px',
                borderRadius: '100px',
                fontSize: '10.5px',
                fontWeight: 700,
                background: 'rgba(21, 128, 61, 0.1)',
                color: 'var(--ui-green)',
              }}
            >
              Web only
            </span>
          )}
          {customTags.map((tag) => (
            <span
              key={tag.id}
              style={{
                padding: '3px 9px',
                borderRadius: '100px',
                fontSize: '10.5px',
                fontWeight: 700,
                backgroundColor: tag.color,
                color: tag.textColor,
              }}
            >
              {tag.text}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductInfo;
